export function setFeatured (state, featuredProducts) {
  state.featured = featuredProducts
}
export function setCategories (state, categories) {
  state.categories = categories
}
